import { ReactComponent as APP_GALLERY } from 'assets/img/appGallery.svg';
import { ReactComponent as APP_STORE } from 'assets/img/appStore.svg';
import { ReactComponent as GOOGLE_PLAY } from 'assets/img/googlePlay.svg';
import { ReactComponent as ICON_FB } from 'assets/img/icon-facebook.svg';
import { ReactComponent as ICON_INSTA } from 'assets/img/icon-instagram.svg';
import { ReactComponent as ICON_IN } from 'assets/img/icon-linkedin.svg';
import { ReactComponent as ICON_TIKTOK } from 'assets/img/icon-tiktok.svg';
import { ReactComponent as ICON_X } from 'assets/img/icon-twitter-x.svg';
import { ReactComponent as ICON_YT } from 'assets/img/icon-youtube.svg';

export const SOCIAL = [
  { label: 'facebook', href: 'https://www.facebook.com/cosmote', Icon: ICON_FB, styles: { width: 'auto', height: 24 } },
  {
    label: 'instagram',
    href: 'https://www.instagram.com/cosmote_greece',
    Icon: ICON_INSTA,
    styles: { width: 'auto', height: 24 },
  },
  {
    label: 'youtube',
    href: 'https://www.youtube.com/user/cosmote',
    Icon: ICON_YT,
    styles: { width: 'auto', height: 24 },
  },
  {
    label: 'tiktok',
    href: 'https://www.tiktok.com/@cosmote',
    Icon: ICON_TIKTOK,
    styles: { width: 'auto', height: 24 },
  },
  { label: 'twitter-x', href: 'https://twitter.com/cosmote', Icon: ICON_X, styles: { width: 'auto', height: 24 } },
  {
    label: 'linkedin',
    href: 'https://gr.linkedin.com/showcase/cosmote',
    Icon: ICON_IN,
    styles: { width: 'auto', height: 24 },
  },
];

export const STORES = [
  {
    label: 'google play',
    href: 'https://play.google.com/store/apps/details?id=gr.cosmote.myaccount.widget',
    Icon: GOOGLE_PLAY,
    styles: { width: 'auto', height: 38 },
  },
  {
    label: 'app store',
    href: 'https://apps.apple.com/us/app/cosmote/id482889196',
    Icon: APP_STORE,
    styles: { width: 'auto', height: 38 },
  },
  {
    label: 'app gallery',
    href: 'https://appgallery.huawei.com/app/C102123117',
    Icon: APP_GALLERY,
    styles: { width: 'auto', height: 38 },
  },
];
